import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { buildPBComponents, getLightboxImages } from '@blaze-cms/plugin-page-builder-fe';
import { Header, MainContextProvider } from '@blaze-cms/nextjs-components';
import { getSearchFilter, checkForGtm } from '../helpers';
import { PREVIEW_MODE } from '../constants';
import { DebugSidebar } from '../components';

const ContentContainer = ({ fullUrl, pageData, isPreview, itemId, itemEntity }) => {
  const [open, setOpen] = useState(false);
  const [debugOptions, setDebugOptions] = useState({ editorModeEnabled: false });
  const [selectedImage, setSelectedImage] = useState(0);
  const toggleModal = () => setOpen(!open);

  useEffect(
    () => {
      if (open) setOpen(false);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [fullUrl]
  );

  const { category, tags, preparedPageBuilderComponents, ...metaProps } = pageData;
  const pageBuilder = preparedPageBuilderComponents || [];
  const options = { parent: { itemId, itemEntity, category, tags } };
  const searchFilterItems = getSearchFilter(pageBuilder);
  const defaultSearchFilter = searchFilterItems[0];
  // TODO check if this can be removed
  if (defaultSearchFilter && !defaultSearchFilter.settings.url) {
    options.searchFilter = defaultSearchFilter;
  }
  options.allSearchFilters = searchFilterItems;
  const lightboxImages = getLightboxImages(pageBuilder);
  const hasGTM = checkForGtm(pageBuilder);
  const GlobalLigthBoxProps = {
    open,
    setOpen,
    toggleModal,
    selectedImage,
    lightboxImages,
    setSelectedImage
  };

  const buildPBComponentsOptions = {
    ...options,
    ...metaProps,
    ...GlobalLigthBoxProps,
    hasGTM
  };

  const updatedDebugOptions = (newOptions = {}) => {
    setDebugOptions({
      ...debugOptions,
      ...newOptions
    });
  };

  return (
    <MainContextProvider value={{ fullUrl, isPreview, itemId, itemEntity, hasGTM, debugOptions }}>
      <Header {...metaProps} />
      <DebugSidebar
        itemId={itemId}
        itemEntity={itemEntity}
        updatedDebugOptions={updatedDebugOptions}
      />
      {isPreview && <div className="preview-header">{PREVIEW_MODE}</div>}
      {!!pageBuilder.length && buildPBComponents(pageBuilder, buildPBComponentsOptions, true)}
    </MainContextProvider>
  );
};

ContentContainer.propTypes = {
  fullUrl: PropTypes.string.isRequired,
  pageData: PropTypes.object.isRequired,
  isPreview: PropTypes.bool.isRequired,
  itemId: PropTypes.string.isRequired,
  itemEntity: PropTypes.string.isRequired
};

export default ContentContainer;
